// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"styles_modalFooter__iV_8g","footerButton":"styles_footerButton__vvhbM"};